import { createRouter, createWebHistory } from 'vue-router';

import { frontendURL } from '../helper/URLHelper';
import dashboard from './dashboard/dashboard.routes';
import store from 'dashboard/store';
import { validateLoggedInRoutes } from '../helper/routeHelpers';
import AnalyticsHelper from '../helper/AnalyticsHelper';

const routes = [...dashboard.routes];

export const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' };
    }
    return { top: 0 };
  },
});

export const validateAuthenticateRoutePermission = (to, next) => {
  const { isLoggedIn, getCurrentUser: user } = store.getters;

  if (!isLoggedIn) {
    window.location.assign('/app/login');
    return '';
  }

  const { accounts = [], account_id: accountId } = user;

  if (!accounts.length) {
    if (to.name === 'no_accounts') {
      return next();
    }
    return next(frontendURL('no-accounts'));
  }

  if (to.name === 'profile_redirect') {
    return next(frontendURL(`accounts/${accountId}/profile/settings`));
  }

  const resolvedName =
    to.name ||
    [...(to.matched || [])].reverse().find(record => record.name)?.name;
  const hasPermissionedMatch = (to.matched || []).some(
    record => (record.meta?.permissions || []).length
  );

  // Nested layouts (event-inbox, inbox-view) can match an unnamed parent
  // before the default child is resolved. Redirecting that as "no name"
  // throws Vue Router's "Redirected when going from ... via a navigation guard".
  if (to.name === 'no_accounts' || (!resolvedName && !hasPermissionedMatch)) {
    const user = store.getters.getCurrentUser;
    const account = (user?.accounts || []).find(
      item => item.id === Number(accountId)
    );
    const isAdmin =
      account?.role === 'administrator' && !account?.custom_role_id;
    const hubVisible = Boolean(account?.onboarding_hub?.visible);
    const home =
      isAdmin && hubVisible
        ? `accounts/${accountId}/onboarding`
        : `accounts/${accountId}/copilot`;
    return next(frontendURL(home));
  }

  const nextRoute = validateLoggedInRoutes(to, store.getters.getCurrentUser);
  return nextRoute ? next(frontendURL(nextRoute)) : next();
};

export const initalizeRouter = () => {
  const userAuthentication = store.dispatch('setUser');

  router.beforeEach((to, _from, next) => {
    AnalyticsHelper.page(to.name || '', {
      path: to.path,
      name: to.name,
    });

    userAuthentication.then(() => {
      return validateAuthenticateRoutePermission(to, next, store);
    });
  });
};

export default router;
